import { atom, useAtom } from "jotai";
import React from "react";

export type PermissionType = "camera" | "photos";

export type PermissionDeniedState =
  | {
      isOpen: false;
    }
  | {
      isOpen: true;
      permissionType: PermissionType;
    };

const permissionDeniedAtom = atom<PermissionDeniedState>({
  isOpen: false,
});

export const usePermissionDeniedModal = () => {
  const [state, setState] = useAtom(permissionDeniedAtom);

  const openModal = React.useCallback(
    (permissionType: PermissionType) => {
      setState({
        isOpen: true,
        permissionType,
      });
    },
    [setState]
  );

  const closeModal = React.useCallback(() => {
    setState({ isOpen: false });
  }, [setState]);

  return {
    state: state,
    openModal: openModal,
    closeModal: closeModal,
  };
};
